import React, {Component} from 'react';
import { getAPI, adminloadTP,  AuthenticatedUser,  stopTimer } from "../../../api";
import Slider from 'react-slick'
import moment from 'moment';
import  './awards.css'

class TournamentAdminAwardSlides extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;

        this.state = {
            loading: true,
            open: false,
            user: user,
            tData: {},
            pid: params.pid,
            awardsData: []
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('awards', 'none', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    getAPI(`/awards/analyze/${this.state.pid}`)
                    .then(result => {
                        this.setState({tData: d2.tournamentPage, awardsData: result.data, tUsers: d2.tUsers, loading: false});   
                    })                 

                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, awardsData } = this.state;

            const settings = {
                dots: true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                autoplay: false,
                //autoplaySpeed: 5000
            };

            return (
                <>
                <section className="blog-detail-page section-b-space" style={{paddingBottom: "2px"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 blog-detail"> 
                                <div className="pull-left">                                                            
                                    <h3 >{tData.title} - Awards Ceremony</h3>  
                                </div>                                                            
                                <div className="pull-right">                                                            
                                    <h3 >{moment(new Date()).format('LLL')}</h3>                                  
                                </div>                                
                            </div>
                        </div>
                    </div>
                </section>

                <div className="container" >           
                    <div className="row">
                        <div className="col-12">
                            <div >
                                <Slider ref={slider => (this.slider = slider)} className="slide-1 home-slider" {...settings}>
                                <div>
                                    <div className="home" style={{height: "70vh", backgroundImage: `url("/assets/images/91.jpg")`}}>
                                        <div className="container">
                                        <div className="row">
                                                <div className="col-12">
                                                    <h1 className="eventHeader">&nbsp;</h1> 
                                                </div>
                                            </div> 
                                            <div className="row">
                                                <div className="col-12">
                                                    <h1 className="eventHeader">&nbsp;&nbsp;&nbsp;Award Ceremony</h1> 
                                                </div>
                                            </div>    
                                        </div>                                
                                    </div>
                                </div>
                                { awardsData.map((childItem ) => 
                                    <div>
                                        <div className="home" style={{height: "70vh", backgroundImage: `url("/assets/images/91.jpg")`}}>
                                            <div className="container">

                                            <div className="row">
                                                <div className="col-5">
                                                    <h1 className="eventHeader">{childItem.event}</h1> 
                                                </div>
                                                <div className="col-5">&nbsp;</div>
                                                <div className="col-5">&nbsp;</div>
                                            </div>

                                               
                                            <div className="row">
                                            <div className="col-2">&nbsp;</div>
                                                <div className="col-5">
                                                    <h1 className="placeHeader">
                                                    {childItem.index}<sup>
                                                        { childItem.index === 3 ? "rd"
                                                        : childItem.index === 2 ? "nd"
                                                        : childItem.index === 1 ? "st" : "th"
                                                        }</sup> Place </h1>                                                                
                                                </div>
                                                <div className="col-5">&nbsp;</div>
                                            </div>

                                            <div className="row"><div className="col-12 largeSpace">&nbsp;</div></div>

                                               
                                            <div className="row">
                                                <div className="col-2">&nbsp;</div>
                                                <div className="col-5">
                                                    <div>
                                                        <h2 className="nameHeader">
                                                        {childItem.displayname}</h2>                                                              
                                                    </div>
                                                </div>
                                                <div className="col-5">&nbsp;</div>
                                            </div>

                                            </div>
                                        </div>
                                    </div>
                                )}  
                                <div>
                                    <div className="home" style={{height: "70vh", backgroundImage: `url("/assets/images/91.jpg")`}}>
                                        <div className="container">
                                        <div className="row">
                                                <div className="col-12">
                                                    <h1 className="eventHeader">&nbsp;</h1> 
                                                </div>
                                            </div> 
                                            <div className="row">
                                                <div className="col-12">
                                                    <h1 className="eventHeader">&nbsp;&nbsp;&nbsp;Thank-you!</h1> 
                                                </div>
                                            </div>    
                                        </div>                                
                                    </div>
                                </div>                                   
                                </Slider>
                                <br />
                            </div>
                        </div>
                    </div>  
                </div>
                </>    
            )
        }
    }
}

export default TournamentAdminAwardSlides;